var map = {
	"./en/btn_1_2.png": "O+rQ",
	"./en/btn_99_2.png": "mTVw",
	"./en/btn_9_2.png": "GB6F",
	"./en/btn_Synthesis_2.png": "farf",
	"./en/btn_gift_2.png": "TA6K",
	"./en/card_1_2.png": "YN8P",
	"./en/card_2_2.png": "ux6w",
	"./en/card_3_2.png": "0Snn",
	"./en/card_4_2.png": "1XCF",
	"./en/card_5_2.png": "4Xeb",
	"./en/king_card_2.png": "ZThn",
	"./es/btn_1_2.png": "DK8S",
	"./es/btn_99_2.png": "c+aD",
	"./es/btn_9_2.png": "MdMT",
	"./es/btn_Synthesis_2.png": "+/9M",
	"./es/btn_gift_2.png": "kqQT",
	"./es/card_1_2.png": "P+dB",
	"./es/card_2_2.png": "xdy/",
	"./es/card_3_2.png": "Y1Kd",
	"./es/card_4_2.png": "Qn6K",
	"./es/card_5_2.png": "QY4+",
	"./es/king_card_2.png": "K5M0",
	"./pt/btn_1_2.png": "M0o3",
	"./pt/btn_99_2.png": "VN4O",
	"./pt/btn_9_2.png": "JDk3",
	"./pt/btn_Synthesis_2.png": "dG5G",
	"./pt/btn_gift_2.png": "yjv8",
	"./pt/card_1_2.png": "octe",
	"./pt/card_2_2.png": "RsKR",
	"./pt/card_3_2.png": "bS7f",
	"./pt/card_4_2.png": "c7JO",
	"./pt/card_5_2.png": "rWW8",
	"./pt/king_card_2.png": "PfsN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sHP3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*_2\.png$
// module id = sHP3
// module chunks = 0